import React, { Component } from "react";
import "./Loader.scss";

class Loader extends Component {
  render() {
    return (
      <div className="SearchingForResult">
        <div className="lds-ring">
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className="SearchingForResultMessage">
         { this.props.message ?
           this.props.message :
           ""
          }
        </div>
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/widget/components/loading/Loader.js